import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { OrderService } from '@services/order.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-managed-board',
  templateUrl: './managed-board.component.html',
  styleUrls: ['./managed-board.component.css'],
})
export class ManagedBoardComponent implements OnInit, OnDestroy {
  navLinks = [
    { path: 'stack', label: 'The Stack' },
    { path: 'job-ready', label: 'Ready / Pickup' },
    { path: 'awaiting-frames', label: 'Awaiting Frames' },
    { path: 'returns', label: 'Returns' },
    { path: 'borrowing', label: 'Borrowing' },
    { path: 'invoices-credits', label: 'Invoice / Credit' },
  ];
  user;
  jobReadyCount = 0;
  private countSub: Subscription;

  constructor(
    private authService: AuthService,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    this.user = this.authService.getUser();
    if (this.user.role === 'RENTAL') {
      this.navLinks = [{ path: 'inventory', label: 'INVENTORY' }];
      return;
    }
    this.countSub = this.orderService.jobReadyCount$.subscribe((count) => {
      this.jobReadyCount = count;
    });
    this.loadJobReadyCount();
  }

  ngOnDestroy(): void {
    this.countSub?.unsubscribe();
  }

  tabLabel(link: { path: string; label: string }): string {
    if (link.path === 'job-ready') {
      return `${link.label} (${this.jobReadyCount})`;
    }
    return link.label;
  }

  private loadJobReadyCount(): void {
    this.orderService.getNewOrders('job-ready').subscribe({
      next: (vendorOrders) => {
        const count = (vendorOrders || []).reduce(
          (total, vendorOrder) => total + ((vendorOrder.orders || []).length),
          0
        );
        this.orderService.setJobReadyCount(count);
      },
    });
  }
}
